export const PERCENT_UNIT = '%';

export function isPercentUnit(unit: string | null | undefined): boolean {
  return unit === PERCENT_UNIT || unit === null || unit === undefined;
}

export function hasNoUnit(unit: string | null | undefined): boolean {
  return unit === '' || unit === '-';
}

export function getUnitLabel(unit: string | null | undefined): string {
  if (isPercentUnit(unit)) {
    return PERCENT_UNIT;
  }
  return hasNoUnit(unit) ? '' : unit;
}

export function getUnitSuffix(unit: string | null | undefined): string {
  const label = getUnitLabel(unit);
  return label ? ' ' + label : '';
}

export function getBarScaleMax(availabilities: any[], byPeriod = false): number | undefined {
  const values = availabilities
    .filter(availability => availability && !isPercentUnit(availability.units))
    .flatMap(availability => {
      const charts = byPeriod ? availability.chart : [availability.chart?.[1]];
      const seriesValues = (charts ?? []).flatMap(item => item?.series ?? []).map(serie => serie.value);
      return [...seriesValues, availability.target];
    })
    .filter(value => Number.isFinite(value));
  return values.length ? Math.max(...values) : undefined;
}

export function toUnitValue(value: number | null | undefined, unit: string | null | undefined): number | null | undefined {
  if (value === null || value === undefined) {
    return value;
  }
  return isPercentUnit(unit) ? value * 100 : value;
}
